import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import GenerateTestPlanModal from './GenerateTestPlanModal';

const TestPlansSection = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card style={{ borderRadius: '6px', border: '1px solid #dee2e6' }}>
        <Card.Body>
          <div className="d-flex flex-column align-items-center text-center p-4">
            <Typography
              variant="h5"
              sx={{
                fontSize: '24px',
                fontWeight: 'bold',
                marginBottom: 1,
                color: '#343a40',
              }}>
              Test Plan Suggestions
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#6c757d',
                fontSize: '16px',
                marginBottom: 3,
                lineHeight: 1.5,
                maxWidth: '600px',
              }}>
              We analyze your test cases and requirements to provide tailored,
              prioritized suggestions for your next test cycle.
            </Typography>
            <Button
              variant="primary"
              className="mt-3"
              style={{
                padding: '12px 24px',
              }}
              onClick={() => setOpen(true)}>
              Generate Test Plan
            </Button>
          </div>
        </Card.Body>
      </Card>
      <GenerateTestPlanModal open={open} handleClose={() => setOpen(false)} />
    </>
  );
};

export default TestPlansSection;
